import { biLogger } from '../biLogger';
import { locale } from '../constants';
import { selectBiData } from '../selectors';
import { BiEventLogger, ChatbotClickOnSolutionBiData } from '../types';
import { getRuntimeDataForBi } from '../utils';

export const logChatbotClickOnSolution: BiEventLogger<ChatbotClickOnSolutionBiData> = async (
  state,
  { solutionType, solutionId }: ChatbotClickOnSolutionBiData,
) => {
  const biData = selectBiData(state);
  const { sessionId, metaSiteId, contextBi, placement } = await getRuntimeDataForBi(state);

  biLogger.chatbotClickOnSolution({
    solution_id: solutionId,
    solution_type: solutionType,
    conversation_id: biData.conversationId,
    intent_id: biData.intentId,
    main_option_name: biData.mainOptionName,
    orig_page_name: biData.origPageName,
    orig_platform: biData.origPlatform,
    context_area: contextBi?.context_area,
    context_domain: contextBi?.context_domain,
    context_iframeurllist: contextBi?.context_iframeurllist,
    context_msid: contextBi?.context_msid,
    context_page_numLevels: contextBi?.context_page_numlevels,
    context_page_queryparams: contextBi?.context_page_queryparams,
    context_page_toplevelroute: contextBi?.context_page_toplevelroute,
    context_page_urlchunks: contextBi?.context_page_urlchunks,
    context_parenturl: contextBi?.context_parenturl,
    context_platform: contextBi?.context_platform,
    context_uuid: contextBi?.context_uuid,
    mapping_product: contextBi?.mapping_product,
    mapping_url: contextBi?.mapping_url,
    user_experience: contextBi?.user_experience,
    session_id: sessionId,
    current_page_name: document.title,
    lang: locale,
    lng: locale,
    placement,
    msid: metaSiteId,
    chatbot_view: contextBi?.chatbot_view,
    chatbot_state: undefined,
    ai_user_intent: undefined,
    ai_user_intent_type: undefined,
  });
};
